import React from 'react';
import {useTranslation} from 'react-i18next';
import Card from '../../../components/common/Card';
import EditPresentationTheme from './EditPresentationTheme';
import PageHeader from '../../../components/common/header/PageHeader';

function EditPresentationThemePage(): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className="l-container">
            <PageHeader title={t('navigation.editTheme')} />
            <div className="u-mt-3" key="create-theme">
                <Card>
                    <EditPresentationTheme />
                </Card>
            </div>
        </div>
    );
}

export default EditPresentationThemePage;
